module.exports = __webpack_public_path__ + "img/grouphead.aa780b7c.png";